import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { OrdersCoServices } from "../services";
import { Globals } from '../../../globals';

/**
 * Generated class for the TpvRoomPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-rooms',
  templateUrl: 'orders-rooms.html',
})
export class OrdersRoomPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals) {
    this.globals.GAtrackView('Orders', 'Orders - Rooms', this.globals.restaurant.email, 'View', 'List rooms', 'Orders', '');

  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-rooms/orders-rooms.ts